import { Stack, Typography } from '@mui/material';
import { PaymentComponent } from 'components';
import { NotifyService } from 'config';
import { STORAGE_KEY } from 'constants/global';
import { SYS_MESS } from 'constants/systemMessage';
import { AC_BASE_REQUEST_STATUS } from 'models/create-request';
import { PAYMENT_METHOD, PAYMENT_STATUS, PAYMENT_TYPE } from 'models/payments';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'routers/routes';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { getBaseRequestAction } from 'store/reducers/overview/actionTypes';
import { updateStatusPayNow } from 'store/reducers/payments';
import {
  checkoutSearchFeeAction,
  paySearchFeeAction,
} from 'store/reducers/payments/actionTypes';
import {
  updateStepTrial,
  updateUrlServiceAgreementPDF,
} from 'store/reducers/trial-request';
import { convertToUtcTime, formatPrice, mergeDateTime } from 'utils';
import { PopupDownloadPDF } from '../RequestDetail/components/PDFs';

function RequestPayment() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { requestDetail } = useAppSelector(
    (state) => state.baseRequest.overallDataSubmit,
  );
  const { urlServiceAgreementPDF } = useAppSelector(
    (state) => state.baseRequest,
  );
  const { baseRequest } = useAppSelector((state) => state.overview);
  const { paymentMethodId, dataCheckoutPayment } = useAppSelector(
    (state) => state.payment,
  );

  useEffect(() => {
    if (!requestDetail && !baseRequest) {
      dispatch(updateStepTrial(1));
    }
    // eslint-disable-next-line
  }, [baseRequest]);

  const getDataSubmit = () => {
    if (baseRequest) {
      return {
        start_datetime: baseRequest.start_datetime,
        end_datetime: baseRequest.end_datetime,
        days_of_week: baseRequest.days_of_week,
        address_id: baseRequest.address_id,
        children_ids: baseRequest.children_ids,
        pets: baseRequest.pets,
        special_requirements: baseRequest.special_requirements,
      };
    }
    return {
      start_datetime: convertToUtcTime(
        mergeDateTime(requestDetail.startDate, requestDetail.startTime),
      ),
      end_datetime: convertToUtcTime(
        mergeDateTime(requestDetail.endDate, requestDetail.endTime),
      ),
      days_of_week: requestDetail.dayOfWeeks.map(Number).sort((a, b) => a - b),
      address_id: requestDetail.address.id,
      children_ids: requestDetail.children.map((item) => item.id),
      pets: {
        cats: requestDetail.pets.includes('Cats'),
        dogs: requestDetail.pets.includes('Dogs'),
      },
      special_requirements: requestDetail.specialRequirements,
    };
  };

  const handleBackAction = () => {
    if (baseRequest?.status === AC_BASE_REQUEST_STATUS.PAYMENT_FAILED) {
      navigate(APP_ROUTES.OVERVIEW.to);
    } else dispatch(updateStepTrial(2));
  };

  const checkoutAction = (isPayNow: boolean) => {
    dispatch(
      checkoutSearchFeeAction({
        data: {
          payment_method_type: isPayNow
            ? PAYMENT_METHOD.PAY_NOW
            : PAYMENT_METHOD.CARD,
        },
        onFailed: () => {
          handleBackAction();
        },
      }),
    );
  };

  const paymentCallback = (isPayNow: boolean, callback?: Function) => {
    const _params = {
      payment_method_id: !isPayNow ? paymentMethodId : undefined,
      payment_method_type: isPayNow
        ? PAYMENT_METHOD.PAY_NOW
        : PAYMENT_METHOD.CARD,
      ...getDataSubmit(),
    };

    dispatch(
      paySearchFeeAction({
        data: _params,
        onSuccess: (qrCode: string) => {
          dispatch(updateStatusPayNow(PAYMENT_STATUS.SUCCESS));
          dispatch(getBaseRequestAction({}));
          if (isPayNow) callback?.(qrCode);
          else {
            dispatch(updateStepTrial(4));
            NotifyService.success(SYS_MESS.SUCCESS.PAYMENT);
          }
        },
        onFailed: () => {
          dispatch(updateStatusPayNow(PAYMENT_STATUS.FAILED));
        },
        onFinally: () => {},
      }),
    );
  };

  return (
    <React.Fragment>
      {urlServiceAgreementPDF && (
        <PopupDownloadPDF
          open={!!urlServiceAgreementPDF}
          urlPDF={urlServiceAgreementPDF}
          onClose={() => dispatch(updateUrlServiceAgreementPDF(''))}
        />
      )}

      <PaymentComponent
        basicFees={
          <Stack direction={'row'}>
            <Typography variant="Components_Column_content" color={'#6d6d6d'}>
              Search Fee
            </Typography>
            <Typography variant="Components_Column_content" color={'#6d6d6d'}>
              {formatPrice(dataCheckoutPayment.amount)}
            </Typography>
          </Stack>
        }
        paymentType={PAYMENT_TYPE.SEARCH_FEE}
        qrCodeKey={STORAGE_KEY.QR_CODE_SEARCH_FEE}
        paymentCallback={paymentCallback}
        handleBackAction={handleBackAction}
        checkoutAction={checkoutAction}
      />
    </React.Fragment>
  );
}

export default RequestPayment;
